import { Dialog, OverlayArrow, Popover, Checkbox } from "react-aria-components"
import classnames from "classnames"
import { Check } from "src/app/components/Icons"

export function ThemePopover({ children, offset = 0, ...props }) {
  const cls = classnames("theme-popover", {
    "p-2": props.p2 || props.padding === 2,
    "p-4": props.p4 || props.padding === 4,
  })
  return (
    <Popover className={cls} offset={offset} {...props}>
      <OverlayArrow>
        <svg width={12} height={12} viewBox="0 0 12 12"></svg>
      </OverlayArrow>
      <Dialog>
        <div className="dot-bg p-2">{children}</div>
      </Dialog>
    </Popover>
  )
}

export function ThemeCheckbox({ ...props }) {
  return (
    <Checkbox {...props}>
      <div
        className={classnames("status", {
          "state--is-selected": props.isSelected,
        })}
      >
        <Check />
      </div>
    </Checkbox>
  )
}
